import { createApp } from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import vuetify from '@/plugins/vuetify'
import { loadFonts } from '@/plugins/webfontloader'
import authenticate from "@/app/middleware/Authenticate";
import "@/assets/css/main.css";
import i18n from '@/i18n';
import $ from 'jquery';


import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

// Configura jQuery como un plugin global de Vue
const app = createApp(App);
app.config.globalProperties.$ = $;

authenticate();
loadFonts();

app
  .use(i18n)
  .use(router)
  .use(store)
  .use(vuetify)
  .mount('#app');
